import { Box, Button, Flex, List, Text, TextField } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { actionsRightWidth } from '../../ReportSchedulerPopup.constants';
import { ListItem } from './components/ListItem/ListItem';
import { useRuleEmailsSection } from './RuleEmailsSection.hooks';
import { messages } from './RuleEmailsSection.messages';
import { RuleEmailsSectionProps } from './RuleEmailsSection.types';

export const RuleEmailsSection = memo<RuleEmailsSectionProps>((props) => {
    const { ruleIndex } = props;

    const { text, setText, emails, handleAdd, handleRemove } = useRuleEmailsSection(ruleIndex);

    return (
        <Flex direction='column' spacing='12' data-qa='rule-emails'>
            <Flex spacing='8' alignItems='end' wrap={false}>
                <Flex grow={1} shrink={0}>
                    <TextField
                        size='small'
                        label={messages.sendEmailsToTitle}
                        placeholder={messages.placeholder}
                        value={text}
                        onChange={setText}
                        onEnter={handleAdd}
                        clearable={false}
                        required
                    />
                </Flex>

                <Flex grow={0} shrink={0} width={actionsRightWidth}>
                    <Button color='blue80' size='small' onClick={handleAdd} disabled={!text} block>
                        {messages.addButton}
                    </Button>
                </Flex>
            </Flex>

            <Box bordered radius='medium' height={176} spacing='4'>
                {emails.length ? (
                    <List>
                        {emails.map((email) => (
                            <ListItem email={email} onDeleteEmail={handleRemove} key={email} />
                        ))}
                    </List>
                ) : (
                    <Box spacing='4 8'>
                        <Text font='label' fontSize='small' color='midnight60'>
                            {messages.useInputAbove}
                        </Text>
                    </Box>
                )}
            </Box>
        </Flex>
    );
});

RuleEmailsSection.displayName = 'RuleEmailsSection';
